export default "__VITE_ASSET__CF2jc_6l__"